
export const PREFIX_CONNECTOR = "-->"
export const PREFIX_EVENT_TYPE = "event_type"
export const PREFIX_ID = "content_id"
export const PREFIX_VIEWMODE = "viewmode"
export const PREFIX_BREAKPOINT_SMALLER_EQUAL = "breakpoint_smaller_equal"
export const PREFIX_BREAKPOINT_LARGER_EQUAL = "breakpoint_larger_equal"
export const PREFIX_PARENT_ID = "parent_id"
export const PREFIX_PARENT_URL = "parent_url"
export const PREFIX_REFERER_DOMAIN = "referer_domain"
export const PREFIX_REFERER_PATH = "referer_path"
export const PREFIX_TAG = "tag"

export const getPrefix = (key: string)=> key+PREFIX_CONNECTOR
export const getId = (key: string, value: string) => getPrefix(key)+value

export const virtualEventType = (value: string)=>{
    if(!value) return []
    return [
        {
            condition:{
                field: "event_type",
                value: value,
                compare: "=",
            },
            group: "",
            title: "Event › "+value,
            id: getId(PREFIX_EVENT_TYPE, value)
        }
    ]
}
export const virtualContentId = (value:string)=>{
    if(!value) return []
    return [
        {
            condition:{
                field: "content_id",
                value: value,
                compare: "=",
            },
            group: "",
            title: "ID › "+value,
            id: getId(PREFIX_ID,value)
        }
    ]
}

export const virtualBreakpoints = (value:string)=>{
    if(!value || value !== parseInt(value)+"") return []
    return [
        {
            condition:{
                field: "breakpoint",
                value: value+"px",
                compare: "<",
            },
            group: "",
            title: "Breakpoint >= "+value,
            id: getId(PREFIX_BREAKPOINT_LARGER_EQUAL, value)
        },
        {
            condition:{
                field: "breakpoint",
                value: value+"px",
                compare: "<=",
            },
            group: "",
            title: "Breakpoint <= "+value,
            id: getId(PREFIX_BREAKPOINT_SMALLER_EQUAL,value),
        }
    ]
}

export const virtualViewMode = (value:string)=>{
    if(!value) return []
    return [
        {
            condition:{
                field: "viewmode",
                value: value,
                compare: "=",
            },
            group: "",
            title: "Viewmode › "+value,
            id: getId(PREFIX_VIEWMODE, value)
        }
    ]
}

export const virtualParent = (value:string)=>{
    if(!value) return []
    return [
        {
            condition:{
                field: "parent_id",
                value: value,
                compare: "=",
            },
            group: "",
            title: "Parent ID › "+value,
            id: getId(PREFIX_PARENT_ID,value),
        },
        {
            condition:{
                field: "parent_url",
                value: value,
                compare: "=",
            },
            group: "",
            title: "Parent Url › "+value,
            id: getId(PREFIX_PARENT_URL,value),
        }
    ]
}

export const virtualRefererDomain = (value:string)=>{
    if(value.match(/^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/i)){
        return [
            {
                condition:{
                    field: "referer_domain",
                    value: value,
                    compare: "=",
                },
                group: "",
                title: "Referer Domain › "+value,
                id: getId(PREFIX_REFERER_DOMAIN,value),
            },
        ]
    }
    return []
}

export const virtualRefererPath = (value:string)=>{
    if(!value) return []
    return [
        {
            condition:{
                field: "referer_path",
                value: value,
                compare: "=",
            },
            group: "",
            title: "Referer Path › "+value,
            id: getId(PREFIX_REFERER_PATH,value),
        }
    ]
}

const tags = [...Array(9)].map((_,index)=>({
    field: "tag"+(index+1),
    value: "",
    compare: "=",
}))

export const virtualTag = (value:string)=>{
    if(!value) return []
    return [
        {
            condition:{
                entries:[
                    ...tags.map(t=>({...t, value})),
                ],
                relation: "OR",
            },
            group: "",
            title: "Tag › "+value,
            id: getId(PREFIX_TAG,value),
        }
    ]
}

export const defaultVirtualOptions = (value:string)=>{
    if(!value) return []
    return [
        ...virtualEventType(value),
        ...virtualContentId(value),
        ...virtualViewMode(value),
        ...virtualRefererDomain(value),
        ...virtualRefererPath(value),
        ...virtualBreakpoints(value),
        ...virtualTag(value),
        ...virtualParent(value),
    ].map(it=>({
        ...it,
        isVirtual: true,
    }))
}

